import {
  Button,
  Menu,
  Text,
} from '@nike/eds';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
 SET_NPOS_FILTERS, setNposValue, setNposErrors, setNposFilters
} from '../../../../redux/actions';
import { getBodyTranslations } from '../../../../redux/selectors';
import { NPOS } from '../../../../utils/constants';
import { getFilterLabelText } from '../nposUtils';
import Filter from '../reusable/Filter';
import TextInput from '../reusable/TextInput/TextInput';

const UPC = ({
  handleChange
}) => {
  const [open, setOpen] = useState(false);
  const [isValueSubmitted, setIsValueSubmitted] = useState(false);
  const [dirtyFlag, setDirtyFlag] = useState(false);

  const dispatch = useDispatch();

  const upcNo = useSelector((state) => state.nposFilters.upc);
  const errors = useSelector((state) => state.nposErrors);
  const translations = useSelector(getBodyTranslations);

  const setUpcNo = (value) => {
    setDirtyFlag(true);
    dispatch(setNposFilters({ upc: value }));
  };

  useEffect(() => {
    dispatch(setNposValue({ openFilter: open ? NPOS.FILTERS.UPC : null }));
  }, [open, dispatch]);

  useEffect(() => {
    const getError = (value) => (value && value.length !== 14 ? translations[NPOS.ERRORS.INVALID_UPC] : null);
    dispatch(setNposErrors({ upcNo: getError(upcNo) }));
  }, [upcNo, translations, dispatch]);

  const onClearFilter = () => {
    setIsValueSubmitted(false);
    setUpcNo('');
  };

  const validateUPC = () => {
    setIsValueSubmitted(true);
  };

  const onFilterCommit = () => {
    if (dirtyFlag) {
      validateUPC();

      handleChange('upcCode', upcNo);

      dispatch({ filter: { upc: upcNo }, type: SET_NPOS_FILTERS });
    }
    setOpen(false);
  };

  const onSetUpcNo = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setUpcNo(value);
    e.stopPropagation();
    return true;
  };

  const Footer = (
    <div className="d-sm-flx flx-jc-sm-fe p2-sm" style={{ gap: '20px' }}>
      {upcNo && (
        <Button
          className="pr2-sm"
          data-testid="upc-clear-button"
          size="small"
          variant="ghost"
          onClick={onClearFilter}
        >
          {translations.RL_ClearFilter}
        </Button>
      )}
      <Button
        data-testid="upc-done-button"
        size="small"
        variant="primary"
        onClick={onFilterCommit}
      >
        {translations.RL_Done}
      </Button>
    </div>
  );

  const Body = (
    <div className="p4-sm d-sm-flx flx-dir-sm-c flx-ai-sm-fs filter-body">
      <div>
        <Text className="eds-type--subtitle-1 ta-sm-l">{translations.RL_UPCcode}</Text>
      </div>
      <div>
        <TextInput
          data-testid="upc-input"
          errorMessage={errors.upcNo}
          hasErrors={!!errors.upcNo}
          id="upcNo"
          labelAlwaysVisible={false}
          maxChars={14}
          placeholder={translations.RL_UpcCode12Digits}
          style={{ minWidth: '300px' }}
          type="number"
          value={upcNo}
          onChange={onSetUpcNo}
        />
      </div>
    </div>
  );

  const openFilterMenu = (value) => {
    setDirtyFlag(false);
    setOpen(value);
  };

  return (
    <Menu
      bodySlot={Body}
      className="npos-filter"
      footerSlot={Footer}
      isOpen={open}
      placement="bottom"
      onClickOutside={onFilterCommit}
    >
      <Filter
        filterId={NPOS.FILTERS.UPC}
        isError={isValueSubmitted && !!errors.upcNo}
        isFilterApplied={!!upcNo}
        label={getFilterLabelText(NPOS.FILTERS.UPC, { upcNo }, translations)}
        open={open}
        setOpen={openFilterMenu}
      />
    </Menu>
  );
};

UPC.propTypes = {
  handleChange: PropTypes.func.isRequired
};

export default UPC;
